import { Spinner } from 'components/Elements';
import { MainLayout } from 'components/Layout';
import { lazyImport } from 'utils/lazyImport';
import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const { LogsRoutes } = lazyImport(() => import('features/logs'), 'LogsRoutes');
const { Dashboard } = lazyImport(() => import('features/misc'), 'Dashboard');

const App = () => {
  return (
    <MainLayout>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <Spinner size="xl" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </MainLayout>
  );
};

export const protectedRoutes = [
  {
    path: '/app',
    element: <App />,
    children: [
      { path: '/app/logs/*', element: <LogsRoutes /> },
      { path: '/app/', element: <LogsRoutes /> },
      { path: '*', element: <Navigate to="." /> },
    ],
  },
];
